export enum EmailStatus {
    Processed = 'processed',
    Unprocessed = 'unprocessed',
    Clicked = 'click',
    Opened = 'open',
    Bounced = 'bounce',
    Dropped = 'drop',
    Deferred = 'deferred',
    Delivered = 'delivered',
}
